<template>
  <div>
    <FITModal ref="deletePolicyModal" reference="deletePolicy" :title="$t('osm.contents.general.delete')" @click="onClickModalDelete">
      <div slot="body">
        <div class="my-4">
          <h5 v-html="$t('osm.contents.general.deletePolicyConfirm',{policyNumber: generalInfo.policyNumber, policyRef: generalInfo.policyReference})"></h5>
        </div>
      </div>
    </FITModal>
    <b-row align-h="center">
      <div class="w-75">
        <b-modal id="cbModal" :size="selectedChangeBusinessAction === 'surrender' ? 'lg': 'md'" ref="cbModal" @ok="onClickModalOk" :ok-variant="isFirstTimeClickedModalOk?'primary':'success'" cancel-variant="danger" @hidden="onHideModal" :title="$t('osm.contents.general.changeBusiness.title') + ' - ' + $t(`osm.contents.general.changeBusiness.${this.selectedChangeBusinessAction}`)">
          <div>
            <p v-html="changeBusinessConfirmContent"></p>
          </div>
          <div class="mt-3">
            <div :class="{'w-50':selectedChangeBusinessAction === 'surrender'}">
              <FITDatePicker :label="$t(`osm.contents.general.changeBusiness.${selectedChangeBusinessAction}`) +' '+$t('general.date')" :width="8" v-model="changeBusinessEffectDate" :placeholder="$t('general.selectDate')"></FITDatePicker>
            </div>
            <FITWorkflowFileUpload v-if="selectedChangeBusinessAction === 'surrender'" ref="fitFileUpload"></FITWorkflowFileUpload>
          </div>
          <div v-if="!isFirstTimeClickedModalOk" class="my-4">
            <h5 v-html="changeBusinessWarning" style="color:red"></h5>
          </div>
          <b-alert :show="modalAlertCd" dismissible variant="danger" @dismissed="modalAlertCd=0">{{$t('general.updateError')}}</b-alert>
        </b-modal>
        <b-alert :show="dismissCountDown" dismissible :variant="submitSuccess?'success':'danger'" @dismissed="dismissCountDown=0">{{$t('general.updateSuccess')}}</b-alert>
        <FITFormCard>
          <b-row slot="header" align-v="center">
            <b-col cols="">
              <h5><i class="fa fa-info-circle mr-2"></i>{{$t('osm.contents.giPolicy.generalInfo')}}</h5></b-col>
            <b-col cols="auto" class="ml-auto">
              <FITButton  v-if="permissionLevel<3.5" class="mr-3" @click="onClickDeletePolicy" variant="warning" :text="$t('osm.contents.general.delete')" size="md"></FITButton>
              <FITDropdown v-if="permissionLevel<3.5" v-model="changeBusinessActions.value.action" variant="primary" :text="changeBusinessActions.label" :options="changeBusinessActions.options" @clicked="onClickChangeBusiness"></FITDropdown>
            </b-col>
          </b-row>
          <div slot="formBody">
            <b-row>
              <b-col cols="7">
                <h3><b><i class="fa fa-align-justify mr-2"></i>{{$t('osm.contents.giPolicy.general')}}</b></h3>
                <div class="mt-3">
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.productName')" :value="productFullName | isEmpty"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.policyType')" :value="getTranslatedPolicyInfoValue('policyType',generalInfo.policyType)"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.policyNumber')" :value="generalInfo.policyNumber"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.policyReference')" :value="generalInfo.policyReference"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.applicationDate')" :value="generalInfo.applicationDate | date"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.applicationReceiveDate')" :value="generalInfo.applicationReceiveDate | date"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.newBusinessOrRenewal')" :value="getTranslatedPolicyInfoValue('newBusinessOrRenewal',generalInfo.newBusinessOrRenewal)"></GIPolicyDetailRow>
                  <!-- <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.originalAgent')" :value="originalAgent.english + ' ' + originalAgent.chinese"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.currentAgent')" :value="currentAgent.english + ' ' + currentAgent.chinese"></GIPolicyDetailRow> -->
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.approveAgent')" :value="
                  approveAgentFullName"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.ownerCustomer')" :value="ownerCustomerFullName"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.insuredCustomer')" :value="insuredCustomerFullName"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.effectiveDate')" :value="generalInfo.effectiveDate | date"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.issueDate')" :value="generalInfo.issueDate | date"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.expiryDate')" :value="generalInfo.expiryDate | date"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.remarks')" :value="isFieldEmpty(generalInfo.remarks)"></GIPolicyDetailRow>
                  <!-- Attachment part -->
                  <template>
                    <dl class="row">
                      <dt class="col-5">{{$t('osm.contents.giPolicy.generalInformation.attachment')}}</dt>
                      <dd class="col-7">
                        <ul class="list-unstyled">
                          <template v-if="attachment.length > 0" v-for="item in attachment">
                            <li><a :href="fileDownloadPrefix+ item.ID">{{item.documentName}}</a></li>
                          </template>
                          <li v-if="attachment.length == 0">N/A</li>
                        </ul>
                      </dd>
                    </dl>
                  </template>
                </div>
              </b-col>
              <b-col cols="5" class="border-left border-grey">
                <b-row>
                  <b-col>
                    <h3><b><i class="fa fa-credit-card mr-2"></i>{{$t('osm.contents.giPolicy.fee')}}</b></h3>
                  </b-col>
                  <b-col cols="auto" class="ml-auto">
                    <p class="h5 bg-danger text-white ml-auto p-2 rounded">{{ $t('osm.contents.giPolicy.generalInformation.policyStatus') }}: {{getTranslatedPolicyInfoValue('policyStatus', generalInfo.policyStatus)}}</p>
                  </b-col>
                </b-row>
                <div class="mt-3">
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.policyCurrency')" :value="generalInfo.policyCurrency"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.modalPremium')" :value="'$' + generalInfo.modalPremium | isEmpty"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.actuallyPaid')" :value="'$' + generalInfo.customerActuallyPaid |  isEmpty"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.premiumPaid')" :value="yesNo(generalInfo.premiumPaid)"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.levyOrMIB')" :value="'$' + generalInfo.levyOrMib |  isEmpty"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.insurerRebate')" :value="'$' + generalInfo.insurerRebate | isEmpty"></GIPolicyDetailRow>
                  <!-- <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.agentCommissionRate')" :value="generalInfo.agentCommissionRate + '%'"></GIPolicyDetailRow> -->
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.policyFee')" :value="'$' + generalInfo.policyFee | isEmpty"></GIPolicyDetailRow>
                </div>
              </b-col>
            </b-row>
            <PolicyAgent v-model="policyAgent" translateKey="osm.contents.lifePolicy.generalInformation.policyAgent" :disabledName="true" :allDisabled="isAgentLocked">
              <div slot="rightTopSection">
                <b-row>
                  <b-col cols="10">
                    <FITAlert ref="alert" :alertContent="alertParams.content" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
                  </b-col>
                  <b-col v-if="permissionLevel<3.5" cols="auto" class="ml-auto">
                    <h3 v-if="isAgentLocked" @click="changeLockStatus" style="cursor:pointer" class="mt-2">
                      <i  class="fa fa-lock"></i>
                    </h3>
                    <b-btn v-else variant="primary" @click="onSaveAgent">{{$t('general.CURD.save')}}</b-btn>
                  </b-col>
                </b-row>
              </div>
              <div slot="afterSection">
                <FITTextarea :width="10" v-model="policyAgentChangeReason" :label="$t('osm.contents.general.agentRemarks')" :disabled="isAgentLocked"></FITTextarea>
              </div>
            </PolicyAgent>
            <hr>
            <b-row>
              <b-col cols="6">
                <h3><b><i class="fa fa-university mr-2"></i>{{$t('osm.contents.giPolicy.payment')}}</b></h3>
                <div class="mt-3">
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.paymentMethod')" :value="getTranslatedPolicyInfoValue('paymentMethod',paymentMethod.paymentMethod)"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.paymentDate')" :value="paymentMethod.paymentDate | date"></GIPolicyDetailRow>
                  <!--                   <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.companyBank')" :value="getTranslatedPolicyInfoValue('companyBank',paymentMethod.companyBank)"></GIPolicyDetailRow> -->
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.paymentReference')" :value="paymentMethod.paymentReference"></GIPolicyDetailRow>
                </div>
              </b-col>
              <b-col cols="6" class="border-left border-grey">
                <h3><b><i class="fa fa-users mr-2"></i>{{$t('osm.contents.giPolicy.commission')}}</b></h3>
                <div class="mt-3">
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.agentCommissionPaid')" :value="yesNo(generalInfo.agentCommissionPaid)"></GIPolicyDetailRow>
                </div>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col cols="12">
                <h3><b><i class="fa fa-user-secret mr-2"></i>{{$t('osm.contents.giPolicy.internalUse')}}</b></h3>
                <div class="mt-3">
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.chequeToInsurer')" :value="generalInfo.chequeToInsurer"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.chequeToInsurerNumber')" :value="generalInfo.chequeToInsurerNumber"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.chequeIssueDate')" :value="generalInfo.chequeIssueDate | date"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.sentOutMedium')" :value="getTranslatedPolicyInfoValue('sentOutMedium',generalInfo.sentOutMedium)"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.sentOutDate')" :value="generalInfo.sentOutDate | date"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.sentOutReference')" :value="generalInfo.sentOutReference | isEmpty"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.companyReceiveDate')" :value="generalInfo.companyReceiveDate | date"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.customerReceiveDate')" :value="generalInfo.customerReceiveDate | date"></GIPolicyDetailRow>
                  <GIPolicyDetailRow :field="$t('osm.contents.giPolicy.generalInformation.agentReceiveDate')" :value="generalInfo.agentReceiveDate | date"></GIPolicyDetailRow>
                </div>
              </b-col>
            </b-row>
          </div>
        </FITFormCard>
        <template>
          <FITFormCard>
            <b-row slot="header" align-v="center">
              <b-col>
                <h5><i class="fa fa-file mr-2"></i>{{$t('osm.contents.giPolicy.policyInfo')}}</h5></b-col>
            </b-row>
            <div slot="formBody">
              <!-- <h3><b><i class="fa fa-align-justify mr-2"></i>{{$t('osm.contents.giPolicy.general')}}</b></h3> -->
              <div class="ml-4">
                <template v-for="(value,key) in filteredTypeInfo">
                  <GIPolicyDetailRow :field="$t(`osm.contents.giPolicy.productInformation.${key}`)" :value="getTranslatedPolicyInfoValue(key,value)"></GIPolicyDetailRow>
                </template>
              </div>
            </div>
          </FITFormCard>
        </template>
      </div>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITDropdown, FITModal, FITDatePicker, FITWorkflowFileUpload, FITButton, FITTextarea, FITAlert } from '@/components'
import { mapGetters, mapState } from 'vuex'
import GIPolicyDetailRow from './GIPolicyDetailRow'
import { PolicyAgent } from '@/Osm/components'
import Vue from 'vue';
import { domain } from '@/api/api.js'


export default {
  name: 'GIPolicyDetail',
  created() {
    this.getSelectionsList();
    this.$store.dispatch('GIPolicy/getGIDetail', true).then(() => {
      // this.getAllName();
    });
  },
  methods: {
    changeLockStatus() {
      Vue.set(this, 'isAgentLocked', !this.isAgentLocked);
    },
    onSaveAgent() {
      this.policyAgent.forEach((item, index, object) => {
        if (item.agentID == null || item.agentID == 0) {
          object.splice(index, 1);
        }
      })
      this.$store.dispatch('GIPolicy/editPolicyAgent', {
        policyID: this.generalInfo.ID,
        policyAgent: this.policyAgent,
        policyAgentChangeReason: this.policyAgentChangeReason,
        policyType: 'G'
      }).then((json) => {
        this.policyAgent.forEach((item) => {
          if (item.isExist) {
            return;
          }
          item.isExist = true;
        })
        Vue.set(this, 'isAgentLocked', true);
        this.$refs.alert.showAlert();
      })
    },
    onClickModalDelete(event) {
      if (!event) {
        return;
      }
      this.$store.dispatch('GIPolicy/deleteGIPolicy', this.generalInfo.ID).then((json) => {
        this.$refs.deletePolicyModal.closeModal();
        this.$store.dispatch('GIPolicy/setWorkflowCurrentStep', 0);
        this.$router.replace({ name: 'GI Policy List', params: { alertContent: this.$t('osm.contents.general.deleteSuccess'), alertVariant: 'success' } });
      })
    },
    onClickDeletePolicy() {
      this.$refs.deletePolicyModal.openModal();
    },
    onHideModal() {
      Vue.set(this, 'isFirstTimeClickedModalOk', true);
      Vue.set(this, 'changeBusinessEffectDate', '');
      Vue.set(this, 'newFileUploaded', {});
    },
    onClickModalOk(evt) {
      evt.preventDefault();
      if (this.isFirstTimeClickedModalOk) {
        Vue.set(this, 'isFirstTimeClickedModalOk', false);
        Vue.set(this, 'submitSuccess', true);
        return;
      }

      switch (this.selectedChangeBusinessAction) {
        case 'lapse':
          var params = { ID: this.generalInfo.ID, policyLapseDate: this.changeBusinessEffectDate }
          this.$store.dispatch('GIPolicy/lapseGI', params).then(() => {
            this.$store.dispatch('GIPolicy/getGIDetail', true);
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();
          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })

          break;
        case 'surrender':
          var fileData = this.uploadFile();
          var params = { ID: this.generalInfo.ID, policyEndDate: this.changeBusinessEffectDate, files: fileData.files, attachment: fileData.attachment }
          this.$store.dispatch('GIPolicy/surrenderGI', params).then(() => {
            this.$store.dispatch('GIPolicy/getGIDetail', true);
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();

          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })
          break;
        case 'reinstate':
          var params = { ID: this.generalInfo.ID, policyReinstateDate: this.changeBusinessEffectDate }
          this.$store.dispatch('GIPolicy/reinstateGI', params).then(() => {
            this.$store.dispatch('GIPolicy/getGIDetail', true);
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();
          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })
          break;
      }

    },
    onClickChangeBusiness(actionType) {
      Vue.set(this, 'selectedChangeBusinessAction', actionType)
      this.$refs.cbModal.show()
    },
    getTranslatedPolicyInfoValue(fieldName, key) {
      var obj = this.allSelections.filter((item) => { return item.name === fieldName });
      if (obj[0] == null) {
        if (key) {
          return key
        }
        return 'N/A'
      }
      if (obj[0].options.length == 0) {
        return 'N/A';
      }
      var filteredType = obj[0].options.filter((item) => {
        return item.selectionKey === key
      });
      var translatedData = this.getTranslatedOptions(this.$i18n.locale, filteredType);
      if (translatedData.length == 0) {
        return key
      }
      return translatedData[0].text
    },
    getAllName() {
      var productNamePayload = { optionType: "gi", searchInput: { ID: this.generalInfo.productID } }
      this.searchOption(productNamePayload, (json) => {
        if (json.length == 0) {
          Vue.set(this.productName, 'chinese', 'N/A');

        } else {
          Vue.set(this.productName, 'chinese', json[0].productChineseName);
          Vue.set(this.productName, 'english', json[0].productEnglishName);
        }
      });
      this.searchAgentOrCustomer("customer", this.generalInfo.insuredCustomer, "insuredCustomer");
      this.searchAgentOrCustomer("customer", this.generalInfo.ownerCustomer, "ownerCustomer");
      this.searchAgentOrCustomer("agent", this.generalInfo.approveAgent, "approveAgent");
      this.searchAgentOrCustomer("agent", this.generalInfo.originalAgent, "originalAgent");
      this.searchAgentOrCustomer("agent", this.generalInfo.currentAgent, "currentAgent");
    },
    searchAgentOrCustomer(optionType, id, dataKey) {
      var payload = { optionType: optionType, searchInput: { ID: id } }
      this.searchOption(payload, (json) => {
        Vue.set(this[dataKey], 'english', json[0].englishFullname);
        Vue.set(this[dataKey], 'chinese', json[0].chineseFullname);
      });
    },
    searchOption(obj, success) {
      var payload = {
        ...obj,
        ...{ dest: "option" },
      }
      this.$store.dispatch('searchOption', payload)
        .then((json) => {
          success(json);
        })
        .catch((err) => {
          console.debug(err);
        });
    },
    getSelectionsList() {
      this.$store.dispatch('getAllSelections', "gi")
        .then((response) => {
          if (response.status != 200) {
            return;
          }
          Vue.set(this, 'allSelections', response.data);
        }, (err) => {
          console.error(err);
        })
    },
    isFieldEmpty(input) {
      return ((input.length > 0) ? input : 'N/A')
    },
    uploadFile() {
      var fileData = this.$refs.fitFileUpload.formUploadFiles();
      console.debug(fileData);
      Vue.set(this, 'newFileUploaded', fileData);
      return fileData;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    showModalAlert() {
      this.modalAlertCd = this.dismissSecs;
    },
    yesNo(val) {
      switch (val) {
        case "Y":
          return this.$t('general.yes');
        case "N":
          return this.$t('general.no');
        default:
          return 'N/A'
      }
    }
  },
  data() {
    return {
      alertParams: {
        content: this.$t('general.updateSuccess'),
        variant: 'success'
      },
      modalAlertCd: 0,
      dismissSecs: 3,
      dismissCountDown: 0,
      submitSuccess: false,
      newFileUploaded: {},
      changeBusinessEffectDate: '',
      isFirstTimeClickedModalOk: true,
      selectedChangeBusinessAction: '',
      fileDownloadPrefix: domain + '/dm/document/download?ID=',
      insuredCustomer: { chinese: '', english: '' },
      ownerCustomer: { chinese: '', english: '' },
      originalAgent: { chinese: '', english: '' },
      currentAgent: { chinese: '', english: '' },
      productName: { chinese: '', english: '' },
      approveAgent: { chinese: '', english: '' },
      allSelections: [],
      changeBusinessActions: {
        value: { rowID: '', action: '' },
        key: 'actions',
        label: this.$t('osm.contents.general.changeBusiness.title'),
        options: [
          { text: this.$t('osm.contents.general.changeBusiness.lapse'), key: 'lapse' },
          { text: this.$t('osm.contents.general.changeBusiness.surrender'), key: 'surrender' },
          { text: this.$t('osm.contents.general.changeBusiness.reinstate'), key: 'reinstate' }
        ]
      },
      policyAgent: [],
      policyAgentChangeReason: '',
      isAgentLocked: true,
    }
  },
  watch: {
    'generalInfo.policyAgent': function(newData, oldData) {
      var policyAgent = JSON.parse(JSON.stringify(newData));
      policyAgent.forEach((item) => {
        item.isExist = true;
      })
      Vue.set(this, 'policyAgent', policyAgent);
    },
  },
  computed: {
   permissionLevel(){
      return this.$store.state.permissionLevel;
    },
    ...mapGetters("GIPolicy", [
      'getTranslatedOptions'
    ]),
    ...mapState({
      generalInfo: state => state.GIPolicy.newGI.giGeneralInfo,
      paymentMethod: state => state.GIPolicy.newGI.giPaymentMethod,
      typeInfo: state => state.GIPolicy.newGI.giTypeInfo,
      attachment: state => state.GIPolicy.newGI.giAttachments
    }),
    filteredTypeInfo() {
      var disallowed = ['version', 'ID', 'generalPolicy']
      var filtered = Object.keys(this.typeInfo)
        .filter(key => !disallowed.includes(key))
        .reduce((obj, key) => {
          return {
            ...obj,
            [key]: this.typeInfo[key]
          };
        }, {});
      return filtered;
    },
    productFullName() {
      if (this.generalInfo.productEnglishName == null) {
        return '';
      }
      return this.generalInfo.productEnglishName + ' ' + this.generalInfo.productChineseName;
    },
    approveAgentFullName() {
      if (this.generalInfo.englishNameApproveAgent == null) {
        return '';
      }
      return this.generalInfo.englishNameApproveAgent + ' ' + this.generalInfo.chineseNameApproveAgent
    },
    ownerCustomerFullName() {
      if (this.generalInfo.englishNameOwnerCustomer == null) {
        return '';
      }
      return this.generalInfo.englishNameOwnerCustomer + ' ' + this.generalInfo.chineseNameOwnerCustomer
    },
    insuredCustomerFullName() {
      if (this.generalInfo.englishNameInsuredCustomer == null) {
        return '';
      }
      return this.generalInfo.englishNameInsuredCustomer + ' ' + this.generalInfo.chineseNameInsuredCustomer
    },
    changeBusinessConfirmContent() {
      return this.$t('osm.contents.general.changeBusiness.confirmActionContent', {
        policyOwner: this.ownerCustomer.english + ' ' + this.ownerCustomer.chinese,
        policyNumber: this.generalInfo.policyNumber
      })
    },
    changeBusinessWarning() {
      return this.$t('osm.contents.general.changeBusiness.confirmActionWarning', {
        action: this.$t(`osm.contents.general.changeBusiness.${this.selectedChangeBusinessAction}`),
      })
    },

    changeBusinessDateFieldName() {
      switch (this.selectedChangeBusinessAction) {
        case 'lapse':
          //lapse
          return this.$t('osm.contents.general.changeBusiness.lapseDate')
        case 'surrender':
          // surrender
          return this.$t('osm.contents.general.changeBusiness.surrenderDate')
        case 'reinstate':
          //reinstate
          return this.$t('osm.contents.general.changeBusiness.reinstateDate')
      }
    },
  },
  destroyed() {
    this.$store.dispatch('GIPolicy/resetNewGIState');
  },
  components: {
    FITTextarea,
    FITFormCard,
    GIPolicyDetailRow,
    FITDropdown,
    FITModal,
    FITDatePicker,
    FITWorkflowFileUpload,
    FITButton,
    PolicyAgent,
    FITAlert
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/GIPolicy/components/GIPolicyDetail/GIPolicyDetail.vue